import { Tokenizer, TokenKind } from "liquidjs";
import React from "react";

function LiquidDisplay({ template }) {
  const tokenizer = new Tokenizer(template);
  const outputTokens = tokenizer.readTopLevelTokens();

  const renderToken = (token) => {
    const content = template.slice(token.begin, token.end);

    switch (token.kind) {
      case TokenKind.Tag:
        return <span style={{ color: "#2563eb", backgroundColor: "#dbeafe" }}>{content}</span>;
      case TokenKind.Output:
        return <span style={{ color: "#059669", backgroundColor: "#d1fae5" }}>{content}</span>;
      case TokenKind.HTML:
        return <span style={{ color: "#4b5563" }}>{content}</span>;
      default:
        return <span>{content}</span>;
    }
  };

  return (
    <div className="font-mono whitespace-pre-wrap p-2">
      {outputTokens.map((token, index) => (
        <React.Fragment key={index}>{renderToken(token)}</React.Fragment>
      ))}
    </div>
  );
}

export default LiquidDisplay;
